// extracted by mini-css-extract-plugin
export default {"link":"style_link__-VxSZ","active":"style_active__Gr5YO","line":"style_line__17sz-","title":"style_title__SAp2-","desc":"style_desc__mShOU"};